/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: drug.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  BatchCreateDrugsRequest,
  BatchCreateDrugsResponse,
  CreateDrugRequest,
  CreateDrugResponse,
  DeleteDrugRequest,
  DeleteDrugResponse,
  GetDrugByJCodeRequest,
  GetDrugByJCodeResponse,
  GetDrugByNDCRequest,
  GetDrugByNDCResponse,
  GetDrugRequest,
  GetDrugResponse,
  GetDrugsBySlugRequest,
  GetDrugsBySlugResponse,
  ListDrugsRequest,
  ListDrugsResponse,
  SearchDrugsByNameRequest,
  SearchDrugsByNameResponse,
  UpdateDrugRequest,
  UpdateDrugResponse,
} from '../types/drug';

export const createDrugService = (transport: Transport) => ({
  async createDrug(
    request: CreateDrugRequest,
    options: RequestOptions = {},
  ): Promise<CreateDrugResponse> {
    const url = getApiPath(API_METHODS.DrugService.CreateDrug);
    return transport.post<CreateDrugResponse>(url, request, options);
  },

  async batchCreateDrugs(
    request: BatchCreateDrugsRequest,
    options: RequestOptions = {},
  ): Promise<BatchCreateDrugsResponse> {
    const url = getApiPath(API_METHODS.DrugService.BatchCreateDrugs);
    return transport.post<BatchCreateDrugsResponse>(url, request, options);
  },

  async getDrug(request: GetDrugRequest, options: RequestOptions = {}): Promise<GetDrugResponse> {
    const { drug_id } = request;
    const url = getApiPath(API_METHODS.DrugService.GetDrug, { drug_id });
    return transport.get<GetDrugResponse>(url, options);
  },

  async getDrugByNdc(
    request: GetDrugByNDCRequest,
    options: RequestOptions = {},
  ): Promise<GetDrugByNDCResponse> {
    const { ndc } = request;
    const url = getApiPath(API_METHODS.DrugService.GetDrugByNDC, { ndc });
    return transport.get<GetDrugByNDCResponse>(url, options);
  },

  async getDrugByJCode(
    request: GetDrugByJCodeRequest,
    options: RequestOptions = {},
  ): Promise<GetDrugByJCodeResponse> {
    const { jcode } = request;
    const url = getApiPath(API_METHODS.DrugService.GetDrugByJCode, { jcode });
    return transport.get<GetDrugByJCodeResponse>(url, options);
  },

  async getDrugsBySlug(
    request: GetDrugsBySlugRequest,
    options: RequestOptions = {},
  ): Promise<GetDrugsBySlugResponse> {
    const { drug_name_slug } = request;
    const url = getApiPath(API_METHODS.DrugService.GetDrugsBySlug, { drug_name_slug });
    return transport.get<GetDrugsBySlugResponse>(url, options);
  },

  async updateDrug(
    request: UpdateDrugRequest,
    options: RequestOptions = {},
  ): Promise<UpdateDrugResponse> {
    const { drug_id, ...body } = request;
    const url = getApiPath(API_METHODS.DrugService.UpdateDrug, { drug_id });
    return transport.post<UpdateDrugResponse>(url, body, options);
  },

  async deleteDrug(
    request: DeleteDrugRequest,
    options: RequestOptions = {},
  ): Promise<DeleteDrugResponse> {
    const { drug_id } = request;
    const url = getApiPath(API_METHODS.DrugService.DeleteDrug, { drug_id });
    return transport.delete<DeleteDrugResponse>(url, options);
  },

  async searchDrugsByName(
    request: SearchDrugsByNameRequest,
    options: RequestOptions = {},
  ): Promise<SearchDrugsByNameResponse> {
    const url = getApiPath(API_METHODS.DrugService.SearchDrugsByName);
    return transport.get<SearchDrugsByNameResponse>(url, { params: request, ...options });
  },

  async listDrugs(
    request: ListDrugsRequest,
    options: RequestOptions = {},
  ): Promise<ListDrugsResponse> {
    const url = getApiPath(API_METHODS.DrugService.ListDrugs);
    return transport.get<ListDrugsResponse>(url, { params: request, ...options });
  },
});

export type DrugService = ReturnType<typeof createDrugService>;
